export const strategies = {
    1: {
        row_id: 1,
        strategy_desc: "1-Fuzzy Touch Double Moving"
    },
    2: {
        row_id: 2,
        strategy_desc: "2-Revised Sling Wave"
    },
    3: {
        row_id: 3,
        strategy_desc: "3-Sling Wave"
    },
    4: {
        row_id: 4,
        strategy_desc: "4-Fuzzy Touch Triple Moving"
    },
    5: {
        row_id: 5,
        strategy_desc: "5-Cross Triple Moving"
    },
    6: {
        row_id: 6,
        strategy_desc: "6-Simple Double Moving"
    },
    7: {
        row_id: 7,
        strategy_desc: "7-Only Wave"
    },
    8: {
        row_id: 8,
        strategy_desc: "8-Revised Only Wave"
    },
    9: {
        row_id: 9,
        strategy_desc: "9-Sling Wave - Cross Sling "
    }
};

export const approachesList = {
    1: {
        approachId: 1,
        approachName: "Only Strategy"
    },
    2: {
        approachId: 2,
        approachName: "Strategy With TP & SL"
    },
    3: {
        approachId: 3,
        approachName: "Mixed Strategies"
    },
    4: {
        approachId: 4,
        approachName: "Mixed Exit Logic"
    },
    5: {
        approachId: 5,
        approachName: "Pretest with Reverse"
    }
};
export const methodsList = {
    1: {
        1: {
            methodId: 1,
            methodName: "Price Range"
        },
        2: {
            methodId: 2,
            methodName: "Price Average"
        }
    },
    2: {
        1: {
            methodId: 1,
            methodName: "Price Range"
        },
        2: {
            methodId: 2,
            methodName: "Price Average"
        }
    },
    3: {
        1: {
            methodId: 1,
            methodName: "E-TP-SL & Callback & Model & Moving"
        },
        2: {
            methodId: 2,
            methodName: "F-TP-SL & Callback & Model"
        }
    },
    4: {
        1: {
            methodId: 1,
            methodName: "H-Strategy 6 with TP-SL & Trailing"
        }
    },
    5: {
        1: {
            methodId: 1,
            methodName: "I-Direct Computing with TP-SL Callback"
        },
        2: {
            methodId: 2,
            methodName: "J-Reverse Exit Logic of I with Static TP-SL"
        },
        3: {
            methodId: 3,
            methodName: "G-Reverse Entrance Logic of J"
        }
    }
};
export const interestsTypeList = {
    0: {
        interestId: 0,
        interestType: "Simple"
    },
    1: {
        interestId: 1,
        interestType: "Compound"
    }
};

export const binanceModes = {
    false: {
        value: false,
        modeDesc: "Trade off"
    },
    true: {
        value: true,
        modeDesc: "Trade on"
    }
};
